import { useGT } from 'gt-react';
import type {
  LeadTimeComponent,
  LeadTimeComponentSource,
} from '@erp/shared-types';
import {
  calculatedSourceForComponent,
  componentSourceChoice,
} from './leadTimeComponentForm';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
export function LeadTimeComponentSourceInput({
  component,
  source,
  onChange,
}: {
  component: LeadTimeComponent;
  source: LeadTimeComponentSource;
  onChange: (source: LeadTimeComponentSource) => void;
}) {
  const gt = useGT();
  return (
    <div className="flex gap-2 items-end">
      <div className="w-28">
        <Label>
          {gt('Source', { context: 'lead time component source selector' })}
        </Label>
        <Select
          value={source.kind}
          onValueChange={(choice) =>
            onChange(componentSourceChoice(component, choice))
          }
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="static">
              {gt('Static', { context: 'lead time source choice' })}
            </SelectItem>
            {calculatedSourceForComponent(component) !== null && (
              <SelectItem value="calculated">
                {gt('Calculated', { context: 'lead time source choice' })}
              </SelectItem>
            )}
          </SelectContent>
        </Select>
      </div>
      {source.kind === 'static' && (
        <div className="w-24">
          <Label>
            {gt('Calendar days', { context: 'lead time static calendar days' })}
          </Label>
          <Input
            type="number"
            min={0}
            max={365}
            step={1}
            value={Number.isNaN(source.days) ? '' : source.days}
            aria-label={gt('Calendar days', {
              context: 'lead time static calendar days',
            })}
            onChange={(event) =>
              onChange({
                kind: 'static',
                days:
                  event.target.value === ''
                    ? Number.NaN
                    : Number(event.target.value),
              })
            }
          />
        </div>
      )}
    </div>
  );
}
